import React from 'react';
import { RFQ } from '../types';
import { getStatusLabel, getStatusColor } from '../utils/statusDisplay';

interface RFQListProps {
    rfqs: RFQ[];
    onSelectRfq?: (rfqId: string) => void;
}

const RFQList: React.FC<RFQListProps> = ({ rfqs, onSelectRfq }) => {
    const formatDate = (dateString: string): string => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    return (
        <div>
            <div className="px-6 py-4 border-b border-[#141414]/15 flex items-baseline justify-between">
                <div>
                    <div className="ff-mono text-[10px] uppercase tracking-[0.2em] text-[#e0461e]">
                        Pipeline
                    </div>
                    <h2 className="ff-serif text-3xl leading-none mt-1">Requests</h2>
                </div>
                <div className="ff-mono text-[11px] text-[#141414]/55">
                    {rfqs.length} total
                </div>
            </div>

            {rfqs.length === 0 ? (
                <div className="px-6 py-10 text-center ff-mono text-xs text-[#141414]/55">
                    No RFQs found. Create your first RFQ to get started.
                </div>
            ) : (
                <div className="overflow-x-auto">
                    <table className="min-w-full">
                        <thead className="bg-[#141414]/[0.03] border-b border-[#141414]/15">
                            <tr>
                                <th className="px-6 py-3 text-left ff-mono text-[10px] uppercase tracking-[0.2em] text-[#141414]/55 font-normal">
                                    Title
                                </th>
                                <th className="px-6 py-3 text-left ff-mono text-[10px] uppercase tracking-[0.2em] text-[#141414]/55 font-normal">
                                    Client
                                </th>
                                <th className="px-6 py-3 text-left ff-mono text-[10px] uppercase tracking-[0.2em] text-[#141414]/55 font-normal">
                                    Part type
                                </th>
                                <th className="px-6 py-3 text-left ff-mono text-[10px] uppercase tracking-[0.2em] text-[#141414]/55 font-normal">
                                    Status
                                </th>
                                <th className="px-6 py-3 text-left ff-mono text-[10px] uppercase tracking-[0.2em] text-[#141414]/55 font-normal">
                                    Created
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {rfqs.map((rfq) => (
                                <tr
                                    key={rfq.id}
                                    className="border-b border-[#141414]/10 last:border-b-0 hover:bg-[#e0461e]/5 cursor-pointer transition"
                                    onClick={() =>
                                        onSelectRfq && onSelectRfq(rfq.id)
                                    }
                                >
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="ff-serif text-lg leading-tight text-[#141414]">
                                            {rfq.title}
                                        </div>
                                        {rfq.description && (
                                            <div className="ff-mono text-[11px] text-[#141414]/55 truncate max-w-xs mt-0.5">
                                                {rfq.description}
                                            </div>
                                        )}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap ff-mono text-xs text-[#141414]">
                                        {rfq.client_name}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap ff-mono text-xs text-[#141414]">
                                        {rfq.part_type || '—'}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <span
                                            className={`px-2 py-1 inline-flex ff-mono text-[10px] uppercase tracking-[0.15em] ${getStatusColor(
                                                rfq.status
                                            )}`}
                                        >
                                            {getStatusLabel(rfq.status)}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap ff-mono text-[11px] text-[#141414]/55">
                                        {formatDate(rfq.created_at)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default RFQList;
